import { Collapse } from "antd";
import styled from "styled-components";

import { PrimaryText } from "@/shared/ui/Typography";

export const StyledColumnNameText = styled(PrimaryText)`
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0%;
    text-align: center;
`;

export const StyledValueText = styled(PrimaryText)`
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0%;
    text-align: center;
    color: ${(props) => props.theme.lightBlue} !important;
`;

export const StyledTotalSumText = styled(PrimaryText)`
    color: ${(props) => props.theme.lightBlue} !important;
`;

export const StyledCollapseWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    z-index: 4;
    padding: 16px;
    display: flex;
    justify-content: center;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        mask: linear-gradient(black, black, rgba(0, 0, 0, 0.3));
        backdrop-filter: blur(16px);
    }
`;

export const StyledCollapse = styled(Collapse)`
    border: none;
    border-radius: 0;
    width: 100%;

    .ant-collapse-item:last-child > .ant-collapse-header,
    .ant-collapse-item:last-child > .ant-collapse-content {
        border-radius: 0;
    }

    .ant-collapse-header {
        background-color: ${(props) => props.theme.darkBlue} !important;
        padding: 10px 16px !important;
        border-radius: 8px !important;
    }

    .ant-collapse-body {
        background-color: ${(props) => props.theme.darkBlue} !important;
        border-top: none;
    }

    .ant-collapse-panel {
        border-top: none;
    }

    .ant-collapse-item-active {
        .ant-collapse-header {
            border-radius: 8px 8px 0 0 !important;
        }
    }
`;

export const StyledTableWrapper = styled.div`
    width: 100%;
    .ant-table-cell {
        padding: 12px 0 !important;
    }

    table {
        border-radius: 0px !important;
    }

    .ant-table,
    .ant-table-cell {
        background: transparent !important;
    }

    tr,
    .ant-table,
    colgroup,
    .ant-table-container {
        border-radius: 0px !important;
    }

    th {
        border-start-start-radius: 0px !important;
        border-start-end-radius: 0px !important;
    }

    td,
    th,
    .ant-table-container {
        border-color: ${(props) => props.theme.middleBlue} !important;
    }
`;
